import type { PlaygroundRunOutputResponse } from "contracts/api/playground";
import { For, Show } from "solid-js";
import { PanelSection } from "./PanelSection";

type Score = PlaygroundRunOutputResponse["scores"][number];
type Judgment = PlaygroundRunOutputResponse["judgments"][number];

/** The scored halves of a run: consolidated metric scores and the per-check
 * judgments the agent emitted, each shown only when it produced rows. */
export function RunScoreTables(props: {
  scores: Score[];
  judgments: Judgment[];
}) {
  return (
    <>
      <Show when={props.scores.length > 0}>
        <PanelSection title="Scores" flush>
          <table class="tbl">
            <thead>
              <tr>
                <th>Metric</th>
                <th>Score</th>
                <th>Detail</th>
              </tr>
            </thead>
            <tbody>
              <For each={props.scores}>
                {(score) => (
                  <tr>
                    <td class="mono">{score.metricKey}</td>
                    <td>{score.score}</td>
                    <td>{score.detail}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </PanelSection>
      </Show>

      <Show when={props.judgments.length > 0}>
        <PanelSection
          title="Check judgments"
          count={props.judgments.length}
          flush
        >
          <table class="tbl">
            <thead>
              <tr>
                <th>Metric</th>
                <th>Check</th>
                <th>Judgment</th>
                <th>Points</th>
                <th>Rationale</th>
              </tr>
            </thead>
            <tbody>
              <For each={props.judgments}>
                {(judgment) => (
                  <tr>
                    <td class="mono">{judgment.metricKey}</td>
                    <td class="mono" title={judgment.question ?? undefined}>
                      {judgment.checkKey}
                      <Show when={judgment.question}>
                        <div class="landing-sub">{judgment.question}</div>
                      </Show>
                    </td>
                    <td>
                      <span class="badge">{judgment.judgment}</span>
                    </td>
                    <td>{judgment.points}</td>
                    <td>{judgment.rationale}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </PanelSection>
      </Show>
    </>
  );
}
